import { GoogleAnalyticsMapperService, GoogleAnalyticsTrackingTag, TrackingProviders, TrackingSettings } from '@iot-platform/core';
import { TrackingEventCategories, TrackingEventIds, TrackingEventLabels, TrackingEventNames } from '@iot-platform/models/kercom';

export const trackingSettings: TrackingSettings = {
  tags: {
    [TrackingEventIds.CONFIGURE_DEVICE_CONNECTOR]: {
      getGoogleTag: (/* data: TrackingData */): GoogleAnalyticsTrackingTag => ({
        eventName: TrackingEventNames.DEVICES_OVERVIEW,
        category: TrackingEventCategories.TOOLBAR_ACTION,
        label: TrackingEventLabels.CONFIGURE_DEVICE_CONNECTOR
      })
    },
  },
  providers: [
    { provider: TrackingProviders.GoogleAnalytics, mapper: GoogleAnalyticsMapperService }
    // The Hotjar tracking mapper is not used yet
    // { provider: TrackingProviders.HotjarAnalytics, mapper: HotjarAnalyticsMapperService }
  ]
};
